package com.neurobs.ccabserver.transcriptreview.states

import com.neurobs.react.ContextBase
import org.scalajs.dom.AudioContext

object AudioContextContext extends ContextBase[AudioContext]{
	override protected def defaultStateValue() = new AudioContext
}
